import React from "react";
import { Circle } from "@speedoc/design-assets/build/icons";

const SolutionsList = ({ list }) => {
  const items = list.list || list;

  return (
    <div className="solutionsList">
      {items.map((item, index) => (
        <div key={index} className="step">
          <Circle />
          <div className="details">
            <div
              className={`title ${item.subtitle ? "" : "noMargin"}`}
              dangerouslySetInnerHTML={{ __html: item.text || item.title }}
            />
            <p className="subtitle">{item.subtitle}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SolutionsList;
